import { Gauge, Sun, ShieldCheck, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useSite, tx } from "@/lib/lang";
import { ui } from "@/lib/uiStrings";
import { Reveal, SectionLabel } from "./Reveal";

const ICONS = { "energy-management": Gauge, "efficiency-transition": Sun, "technical-risk": ShieldCheck };

export default function Servizi() {
  const { content, lang } = useSite();
  const servizi = content.servizi || [];

  return (
    <section id="servizi" data-testid="servizi-section" className="py-16 lg:py-24 bg-surface/30 border-y border-ice/5">
      <div className="mx-auto max-w-7xl px-6">
        <Reveal className="max-w-2xl">
          <SectionLabel>{ui[lang].labels.servizi}</SectionLabel>
          <h2 className="mt-5 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-snug text-ice">
            {tx(content.sezioni?.servizi?.heading, lang) || ui[lang].servizi.heading}
          </h2>
          <p className="mt-4 text-base text-muted-foreground">{tx(content.sezioni?.servizi?.sub, lang) || ui[lang].servizi.sub}</p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
          {servizi.map((s, i) => {
            const Icon = ICONS[s.id] || Gauge;
            return (
              <Reveal key={s.id} delay={i * 0.08}>
                <Link to={`/soluzioni/${s.id}`} className="block h-full">
                <div
                  data-testid={`service-card-${s.id}`}
                  className="group h-full bg-carddark/60 border border-ice/8 rounded-2xl p-8 hover:border-royal/60 hover:bg-carddark transition-colors duration-300 relative overflow-hidden flex flex-col cursor-pointer"
                >
                  <div className="absolute -top-16 -right-16 w-40 h-40 rounded-full bg-royal/10 blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  <div className="flex items-start justify-between">
                    <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-royal/15 border border-royal/30 text-azure group-hover:scale-110 transition-transform duration-300">
                      <Icon size={22} />
                    </span>
                  </div>
                  <h3 className="mt-6 font-display text-lg sm:text-xl font-semibold tracking-tight text-ice leading-snug">{tx(s.title, lang)}</h3>
                  <p className="mt-2.5 text-sm text-muted-foreground leading-relaxed">{tx(s.desc, lang)}</p>
                  <div className="mt-6 flex flex-wrap gap-2">
                    {(s.items?.[lang] || s.items?.it || []).map((item, j) => (
                      <span key={j} className="text-xs text-ice/75 border border-ice/10 rounded-full px-3 py-1.5 bg-onyx/40">
                        {item}
                      </span>
                    ))}
                  </div>
                  <span className="mt-auto pt-6 inline-flex items-center gap-1.5 text-sm font-medium text-azure group-hover:gap-2.5 transition-all">
                    {lang === "it" ? "Scopri tutti i servizi" : "Explore all services"}
                    <ArrowUpRight size={15} />
                  </span>
                </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
